"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const marqueeContainer = "pl-m1t77n1p";
const marqueeStyles = "pl-macgsi1";

/**
 * Marquee Component.
 *
 * @param {Object} props React props
 * @param {Boolean} props.play Play State
 * @param {Boolean} props.pauseOnHover Pause When Hover
 * @param {Boolean} props.pauseOnClick Pause When Click
 * @param {String} props.direction LTR | RTL Slide Direction
 * @param {Number} props.speed Animation Speed
 * @param {Number} props.delay Animation delay default = 0
 * @param {Node} props.children Node
 * @returns {React.ReactElement} Marquee Component
 * @public
 */

function Marquee({
  play = true,
  pauseOnHover = false,
  pauseOnClick = false,
  direction = 'left',
  speed = 20,
  delay = 0,
  children
}) {
  const [hovering, setHovering] = (0, _react.useState)(false);
  const [clicking, setClicking] = (0, _react.useState)(false);
  const marqueeRef = (0, _react.useRef)(null);
  const marqueeWidth = (0, _patternLibraryUtils.useWidthObserver)(marqueeRef);
  const directionVar = direction === 'left' ? 'normal' : 'reverse';
  const duration = marqueeWidth / speed;
  const pausedByHover = pauseOnHover && hovering;
  const pausedByClick = pauseOnClick && clicking;
  const isRunning = play && !pausedByClick && !pausedByHover;
  (0, _react.useEffect)(() => {
    const refCurrent = marqueeRef.current;
    if (refCurrent) {
      refCurrent.style.setProperty('--play', isRunning ? 'running' : 'paused');
      refCurrent.style.setProperty('--direction', directionVar);
      refCurrent.style.setProperty('--duration', `${duration}s`);
      refCurrent.style.setProperty('--delay', `${delay}s`);
    }
  }, [isRunning, directionVar, duration, delay]);
  const conditionalStyles = {
    '--play': isRunning ? 'running' : 'paused',
    '--direction': directionVar,
    '--duration': `${duration}s`,
    '--delay': `${delay}s`
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "fast-marquee",
    onMouseEnter: () => setHovering(true),
    onMouseLeave: () => setHovering(false),
    onTouchStart: () => setClicking(true),
    onTouchEnd: () => setClicking(false),
    className: marqueeContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: marqueeRef,
    className: marqueeStyles,
    style: conditionalStyles
  }, children), /*#__PURE__*/_react.default.createElement("div", {
    ref: marqueeRef,
    className: marqueeStyles,
    style: conditionalStyles
  }, children));
}
var _default = exports.default = Marquee;
Marquee.propTypes = {
  play: _propTypes.default.bool,
  pauseOnHover: _propTypes.default.bool,
  pauseOnClick: _propTypes.default.bool,
  direction: _propTypes.default.oneOf(['left', 'right']),
  speed: _propTypes.default.number,
  delay: _propTypes.default.number,
  children: _propTypes.default.node
};